import React, { MouseEventHandler } from 'react';
import { GamePlayer, GamePlayerMark, PlayerX } from '../../utils';

import styles from './styles.module.css';

interface CellProps {
  onClick: MouseEventHandler<HTMLDivElement>;
  mark?: GamePlayer | undefined;
  row: number;
  col: number;
}

const Cell = (props: CellProps) => {
  return (
    <div
    data-row={props.row}
    data-col={props.col}
    data-mark={props.mark}
    onClick={props.onClick}
    className={`${styles['cell']} ${props.mark && styles[props.mark === PlayerX ? 'x' : 'o']}`}>
      { props.mark && GamePlayerMark[props.mark]}
    </div>
  );
}

export default Cell;